module.exports = __webpack_public_path__ + "img/level-7.b597d3be.svg";